import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { UserProvider } from './user';
import { Dataset, DatasetType } from './dataset';
import { BrainVersionType } from './brain';

export enum Brand {
    Sony = 'Sony',
    FLIR = 'FLIR',
    None = 'None'
}

export enum BrandSensor {
    SonyIMX500 = 'IMX 500',
    FLIRFireflyDL = 'Firefly DL',
    None = ''
}

export enum DownloadState {
    Initializing,
    Ready,
    Downloading,
    Error
}

@Injectable()
export class WhiteLabelProvider extends BaseProvider {
    private brainName: string | null = null;
    private sensorName: string | null = null;

    constructor(private userProvider: UserProvider) {
        super();
    }

    public getBrainName(): string | null {
        if (this.brainName !== undefined && this.brainName != null) {
            return this.brainName;
        }

        const brand = this.getBrand();
        this.brainName = this.getBrainNameFromBrand(brand);
        return this.brainName;
    }

    public getSensorName(): string | null {
        if (this.sensorName !== undefined && this.sensorName != null) {
            return this.sensorName;
        }

        const brand = this.getBrand();
        this.sensorName = this.getSensorNameFromBrand(brand);
        return this.sensorName;
    }

    private getBrand(): Brand {
        if (this.userProvider.isFireflyUser()) {
            return Brand.FLIR;
        } else if (this.userProvider.isSonyUser()) {
            return Brand.Sony;
        } else {
            return Brand.None;
        }
    }

    /**
     * Generate the full brain name, which may include the company name or not
     * This is what will be shown on the Evaluate Page and titles/buttons generally
     */
    private getBrainNameFromBrand(brand: Brand): string | null {
        if (brand == Brand.FLIR) {
            return `${Brand.FLIR} ${BrandSensor.FLIRFireflyDL}`;
        } else if (brand == Brand.Sony) {
            return BrandSensor.SonyIMX500;
        }

        return null;
    }

    /**
     * Just return the sensor name.  This might be used if we don't want
     * to include the company name, or if we have to shorten the string a bit.
     */
    private getSensorNameFromBrand(brand: Brand): string | null {
        if (brand == Brand.FLIR) {
            return BrandSensor.FLIRFireflyDL;
        } else if (brand == Brand.Sony) {
            return BrandSensor.SonyIMX500;
        }

        return null;
    }

    public resetInfo(): void {
        this.brainName = null;
    }

    public getRequiredBrainVersionType(dataset: Dataset): BrainVersionType {
        switch (dataset.type) {
            case DatasetType.SceneRecognition:
                return BrainVersionType.Frozen;

            case DatasetType.AnomalyRecognition:
                return BrainVersionType.AnomalyHiFi;

            case DatasetType.ObjectDetection:
            default:
                return BrainVersionType.Learning;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/white-label.ts